import { v4 as uuidv4 } from 'uuid';

import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { Submenu } from '../../../../vtex-apps/menu/Submenu/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

import { Image } from '../../../../vtex-apps/store-components/Image/default';
const StoreMenuDesktop = () => {
	const menuFinalItems = (menuNumber, submenuNumber) => [
		VisibilityLayout({ mzTitle: `Menu SubItem ${menuNumber}.${submenuNumber} (On/Off)` }, [
			FlexLayoutCol({ blockClass: 'main-menu-menu-4' }, [
				Menu({
					blockClass: 'main-menu-menu-4',
					mzTitle: `Menu - Desktop ${menuNumber}.${submenuNumber}`,
					items: [...Array(7).keys()].map((item) => MenuItem({ id: `menu-item-category-home-${item}` }).props),
				}),
			]),
		]),
		VisibilityLayout({ mzTitle: `Banner  ${menuNumber}.${submenuNumber} (On/Off)`, visible: submenuNumber !== 4 }, [
			FlexLayoutCol({ blockClass: 'main-menu-banner-4' }, [
				Image({
					blockClass: 'menu-subitem-4-img',
					mzTitle: `MZ | Menu Banner ${menuNumber}.${submenuNumber}`,
					src: 'https://via.placeholder.com/250x350',
					ulr: '#',
				}),
			]),
		]),
	];
	const mountAllLists = (menu) => {
		let AllLists = [];
		for (let i = 1; i < 5; i++) AllLists = [...AllLists, ...menuFinalItems(menu, i)];
		return AllLists;
	};

	return {
		componentName: 'FlexLayoutRow',
		componentGroup: 'StoreMenuDesktop',
		componentId: uuidv4(),
		variables,
		props: FlexLayoutRow({ colSizing: 'equal', blockClass: 'menu-desk-4__row' }).props,
		childrenComponents: [
			FlexLayoutCol({}, [
				Menu(
					{ blockClass: 'menu-desk-4__menu', mzTitle: 'Menu Header - Desktop' },
					[...Array(7).keys()].map((menu) =>
						VisibilityLayout({ mzTitle: `MZ | Menu Item ${menu} (On/Off)` }, [
							MenuItem(
								{
									id: `menu-item-dep${menu}`,
									blockClass: 'menu-desk-4__menu-item',
									mzTitle: `MZ | Menu Item ${menu}`,
									type: 'custom',
									itemProps: {
										text: `Categoria ${menu}`,
										type: 'internal',
										href: '#',
									},
								},
								[],
								[
									Submenu({ blockClass: 'menu-desk-4__submenu', width: '100%' }, [
										FlexLayoutRow(
											{
												blockClass: 'main-menu-department-block-4',
												colSizing: 'auto',
												fullWidth: false,
												colGap: 4,
												experimentalHideEmptyCols: true,
											},
											mountAllLists(menu),
										),
									]),
								],
							),
						]),
					),
				),
			]),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--menu-desktop-4-menu-bg-color', name: 'Menu Background' },
			{ from: '--text-color-4-dark', to: '--menu-desktop-4-menu-text-color', name: 'Menu Text' },
			{ from: '--text-color-4-light', to: '--menu-desktop-4-menu-text-hover-color', name: 'Menu Text Hover' },
			{ from: '--text-color-4-dark', to: '--menu-desktop-4-submenu-text-color', name: 'Submenu Text' },
			{ from: '--white', to: '--menu-desktop-4-submenu-bg-color', name: 'Submenu Background' },
			{ from: '--text-color-4-dark', to: '--menu-desktop-4-submenu-border-color', name: 'Submenu Border' },
			{
				from: '--neutral-color-high-medium',
				to: '--menu-desktop-4-submenu-item-hover-color',
				name: 'Submenu Item Hover',
			},
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-none', to: '--menu-desktop-4-border-radius', name: 'Border Radius' },
			{ from: '--border-radius-sm', to: '--menu-desktop-4-submenu-br', name: 'Submenu' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--menu-desktop-4-main-size', name: 'Main font Size' },
			{ from: '--font-size-xs', to: '--menu-desktop-4-submenu-fs', name: 'Submenu' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--menu-desktop-4-menu-weight', name: 'Menu font weight' },
			{ from: '--font-weight-400', to: '--menu-desktop-4-submenu-fw', name: 'Submenu' },
		],
	},
	{
		type: 'borderWidth',
		list: [{ from: '--border-width-hairline', to: '--menu-desktop-4-border-width', name: 'Border Width' }],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-nano', to: '--menu-desktop-4-menu-height', name: 'Menu Line Height' },
			{ from: '--spacing-xs', to: '--menu-desktop-4-submenu-gap', name: 'Submenu Items Gap' },
			{ from: '--spacing-sm', to: '--menu-desktop-4-submenu-lateral-padding', name: 'Submenu Lateral Padding' },
		],
	},
];

export default StoreMenuDesktop;
